import { Iso8601DateTimeString } from '../../../types/Iso8601DateTimeString';
import { MILLISECONDS_IN_DAY } from '../time.constants';

export const isNoticeDaysExceeded = (dateDelivery: Iso8601DateTimeString, noticeDays: number): boolean => {
    const differenceInMs = new Date(dateDelivery).getTime() - new Date().getTime();
    const differenceInDays = Math.ceil(differenceInMs / MILLISECONDS_IN_DAY);

    return differenceInDays < noticeDays;
};
